import React from "react"
import { StudyTabs, TabPane } from '@/components/StudyTabs'
import {useParams} from "react-router-dom"
import ManagerList from './ManagerList'
import EchelonList from './EchelonList'
import EvaluationList from './EvaluationList'

const Construction: React.FC = () => {
  const { id } = useParams()

  return (
    <main className='wrap-scheme header-top'>
      <StudyTabs activeKey={id}>
        <TabPane title="人才管理" key="1">
          <ManagerList />
        </TabPane>
        <TabPane title="人才梯队" key="2">
          <EchelonList />
        </TabPane>
        <TabPane title="人才测评" key="3">
          <EvaluationList />
        </TabPane>
      </StudyTabs>
    </main>
  )
}

export default Construction